import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { getNpsFormBySlug, updateNpsForm } from "../../apis/nps";
import { RENDER_NPS_URL_PREFIX } from "../../constants/forms.constants";
import { createNpsSurveyCreator } from "../../utils/forms.functions";
import EditorLayout from "../shared/EditorLayout";
var NpsEditor = function () {
    var config = useMemo(function () { return ({
        listPath: "/nps/list",
        urlPrefix: RENDER_NPS_URL_PREFIX,
        fetchApi: getNpsFormBySlug,
        updateApi: updateNpsForm,
        createCreator: createNpsSurveyCreator,
        defaultAuthRequired: false,
    }); }, []);
    return _jsx(EditorLayout, { config: config });
};
export default NpsEditor;
